export default [
  {
    path: '/geofence',
    name: 'Zone',
    component: () => import('@/components/master/zone/Zone'),
    meta: {
      title: 'Zone',
      requiresAuth: true,
      services: ['Zone']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/geofenceModule.js